import axios from "axios";

// Use relative URL to leverage Vite proxy
// const API_BASE_URL = "http://192.168.1.41:9091/api/v1";
const API_BASE_URL = "/api/v1";
const COUNSELLOR_API_BASE_URL = "http://103.186.133.119:5177/api/v1";
// const COUNSELLOR_API_BASE_URL = "https://counsellor.echobuddy.in/api/v1";

export const createAppointment = async (appointmentData) => {
  try {
    const response = await axios.post(`${COUNSELLOR_API_BASE_URL}/appointments`, appointmentData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // Returns { success: true, data: {...} }
  } catch (error) {
    console.error("Error creating appointment:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllDoctors = async (account_id) => {
  try {
    // const response = await axios.get(`${COUNSELLOR_API_BASE_URL}/doctors?app_name=musiccare&account_id=${account_id}`);
     const response = await axios.get(`${COUNSELLOR_API_BASE_URL}/doctors?app_name=musicccare&account_id=${account_id}`);
    return response.data;
  } catch (error) {
    console.error(":x: Error fetching doctors:", error);
    throw error;
  }
};

export const getDoctorSlots = async (doctorId, startDate, endDate, isBooked = false) => {
  try {
    const response = await axios.get(
      `${COUNSELLOR_API_BASE_URL}/doctors/${doctorId}/slots`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          is_booked: isBooked
        },
      }
    );
    return response.data; // return the actual data
  } catch (error) {
    console.error("Error fetching doctor slots:", error);
    throw error;
  }
};
export const listAppointments = async (userId) => {
  try {
    const response = await axios.get(`${COUNSELLOR_API_BASE_URL}/appointments`, {
       params: { 
                user_id: userId,
                app_name: "musiccCare"
            } // pass patient_id as query param
    });
    return response.data;
  } catch (error) {
    console.error(" Error fetching appointments:", error);
    throw error;
  }
};


export const listViewAppointments = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/veiwappointments`);
    return response.data;
  } catch (error) {
    console.error("\u274c Error fetching view appointments:", error);
    throw error;
  }
};

// export const getAppointmentProfileById = async (id) => {
//   try {
//     const response = await axios.get(`${API_BASE_URL}/appointment/profile/${id}`);

//     // Backend returns { message, profile }
//     return response.data.profile;
//   } catch (error) {
//     console.error(
//       "Error fetching appointment profile:",
//       error.response?.data || error.message
//     );
//     throw error;
//   }
// };
export const getAppointmentProfileById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/appointment/profile/${id}`);
  return response.data;  // return full response
};

export const changeAppointmentPassword = async (id, oldPassword, newPassword) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/appointment/${id}/password`,
      {
        old_password: oldPassword,
        new_password: newPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error changing password:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getAppointmentById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/appointment/${id}`);

    return response.data; // full appointment object
  } catch (error) {
    console.error(
      "Error fetching appointment by ID:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const incrementBookedAppointment = async (customerId) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/appointment/increment/${customerId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error incrementing booked appointment:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const checkAppointmentLimit = async (customerId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/appointment/check-limit/${customerId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error checking appointment limit:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const checkSubscriptionStatus = async (customerId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/appointment/check-subscription/${customerId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error checking subscription status:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const decrementBookedAppointment = async (customerId) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/appointment/decrement/${customerId}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error decrementing booked appointment:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteAppointment = async (appointmentId, data) => {
    try {
        const response = await axios.patch(`${COUNSELLOR_API_BASE_URL}/appointments/${appointmentId}`, data, {
            headers: {
                'Content-Type': 'application/json',
                // Add auth header if needed
                // 'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to patch appointment:', error);
        throw error.response?.data || error;
    }
};

export const cancelAppointment = async (appointmentId) => {
    try {
        const response = await axios.patch(`${COUNSELLOR_API_BASE_URL}/appointments/${appointmentId}`, {
            status: 'cancelled',
            app_name: 'musiccare'
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to cancel appointment:', error);
        throw error.response?.data || error;
    }
};

